import type { FC } from "react";

import {
  Command,
  CommandEmpty,
  CommandInput,
  CommandItem,
  CommandList
} from "@/components/ui/command";

import type { FormOption } from "../types";

type Props = {
  catalog: readonly FormOption[];
  /** Copies of each form number already there, shown as "N Selected". */
  counts: ReadonlyMap<string, number>;
  onPick: (form: FormOption) => void;
  /** How a count reads; "2 Selected" by default. */
  countLabel?: (n: number) => string;
  testIdPrefix?: string;
};

/** Searchable list of every form CaseBlink fills (Fill Forms' Add Form, the tree's Add Form). */
export const FormPicker: FC<Props> = ({
  catalog,
  counts,
  onPick,
  countLabel = (n) => `${n} Selected`,
  testIdPrefix = "workflow-forms-option"
}) => (
  <Command>
    <CommandInput placeholder="Search Forms" />
    <CommandList className="max-h-64">
      <CommandEmpty>No form found.</CommandEmpty>
      {catalog.map((f) => {
        const n = counts.get(f.formNumber) ?? 0;
        return (
          <CommandItem
            key={f.formNumber}
            value={`${f.formNumber} ${f.title}`}
            onSelect={() => onPick(f)}
            className="text-sm"
            data-testid={`${testIdPrefix}-${f.formNumber}`}
          >
            <span className="shrink-0 font-medium text-fg">{f.formNumber}</span>
            <span className="min-w-0 flex-1 truncate text-fg-3">{f.title}</span>
            {n ? (
              <span className="shrink-0 text-fg-3">{countLabel(n)}</span>
            ) : null}
          </CommandItem>
        );
      })}
    </CommandList>
  </Command>
);
